module.exports = __webpack_public_path__ + "static/media/fade.d11d29c0.png";